function cov_193h5gbf99() {
    var path = "/opt/buildhome/repo/packages/kg-portal/src/js/index.tsx";
    var hash = "4dd90ae142fbd799447ec068776b268503e8e0f1";
    var global = new Function("return this")();
    var gcv = "__coverage__";
    var coverageData = {
        path: "/opt/buildhome/repo/packages/kg-portal/src/js/index.tsx",
        statementMap: {
            "0": {
                start: {
                    line: 13,
                    column: 23
                },
                end: {
                    line: 15,
                    column: 1
                }
            },
            "1": {
                start: {
                    line: 17,
                    column: 18
                },
                end: {
                    line: 17,
                    column: 59
                }
            },
            "2": {
                start: {
                    line: 18,
                    column: 13
                },
                end: {
                    line: 18,
                    column: 35
                }
            },
            "3": {
                start: {
                    line: 21,
                    column: 0
                },
                end: {
                    line: 21,
                    column: 38
                }
            },
            "4": {
                start: {
                    line: 23,
                    column: 0
                },
                end: {
                    line: 23,
                    column: 31
                }
            },
            "5": {
                start: {
                    line: 25,
                    column: 0
                },
                end: {
                    line: 31,
                    column: 2
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            "0": 0,
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0
        },
        f: {},
        b: {},
        _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
        hash: "4dd90ae142fbd799447ec068776b268503e8e0f1"
    };
    var coverage = global[gcv] || (global[gcv] = {});
    if (!coverage[path] || coverage[path].hash !== hash) {
        coverage[path] = coverageData;
    }
    var actualCoverage = coverage[path];
    {
        cov_193h5gbf99 = function () {
            return actualCoverage;
        };
    }
    return actualCoverage;
}
cov_193h5gbf99();
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './i18n';
import KineticGrid from './components/views/KineticGrid';
import { setAxiosResponseInterceptors, store } from './redux';
import '../css/index.scss';
const tagManagerArgs = (cov_193h5gbf99().s[0]++, {
    gtmId: 'GTM-5WL4KTH'
});
const container = (cov_193h5gbf99().s[1]++, document.getElementById('root-container'));
const root = (cov_193h5gbf99().s[2]++, createRoot(container));
cov_193h5gbf99().s[3]++;
TagManager.initialize(tagManagerArgs);
cov_193h5gbf99().s[4]++;
setAxiosResponseInterceptors();
cov_193h5gbf99().s[5]++;
root.render(React.createElement(Provider, {
    store: store
}, React.createElement(BrowserRouter, null, React.createElement(KineticGrid, null))));
